import {
  BatchJobEngine,
  SortDirection,
  useRunExportJobMutation,
} from '@warebee/frontend/data-access-api-graphql';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValue } from 'recoil';
import { AsyncLoadStatus } from '../common/types';
import DatasetTable from '../components/DatasetTable';
import { ButtonSwitchMultiOption } from '../components/actions/ButtonSwitchMulti';
import { Container } from '../components/layout/ContainerFlex';
import { brandName } from '../store/global.state';
import {
  warehouseSelected,
  warehouseSelectedId,
} from '../store/warehouse.state';

import useLoadProcessingJobs from './hooks/useLoadProcessingJobs';
import {
  processingJobsData,
  processingJobsDataStatus,
  processingJobsDataTableState,
} from './store/processingJobs.state';
import {
  ProcessingJobsDataColumn,
  ProcessingJobsDataRow,
} from './store/processingJobs.types';
import useProcessingJobsTableConfig from './useProcessingJobsTableConfig';

export type ProcessingJobsTableProps = {};

const ProcessingJobsTable: React.FC<ProcessingJobsTableProps> = props => {
  const { t } = useTranslation('simulation');
  const brandTitleState = useRecoilValue(brandName);
  const warehouse = useRecoilValue(warehouseSelected);
  const warehouseIdState = useRecoilValue(warehouseSelectedId);

  const processingJobs = useRecoilValue(processingJobsData);
  const loadStatus = useRecoilValue(processingJobsDataStatus);
  const [state, setState] = useRecoilState(processingJobsDataTableState);
  const [runExportCSV] = useRunExportJobMutation();
  const [loadCallback, cancelLoad, reset] = useLoadProcessingJobs();
  const { searchValues, sortValues } = state;
  const columnsConfig = useProcessingJobsTableConfig({
    // withTargetColumns: _.isNil(props.targetId),
  });
  const [selectedJobs, setSelectedJobs] = useState<ProcessingJobsDataRow[]>([]);
  const [engine, setEngine] = useState<BatchJobEngine>(null);
  const [restartStatus, setRestartStatus] = useState<AsyncLoadStatus>(
    AsyncLoadStatus.Ok,
  );
  const [removeStatus, setRemoveStatus] = useState<AsyncLoadStatus>(
    AsyncLoadStatus.Ok,
  );

  useEffect(() => {
    callDataLoad(searchValues, sortValues);
  }, [searchValues, sortValues]);

  useEffect(() => {
    return () => {
      reset();
    };
  }, []);

  // function getFilter(): ProcessingJobsFilter {
  //   const filter: ProcessingJobsFilter = {
  //     status: searchValues?.status
  //       ? [searchValues.status as BatchJobStatus]
  //       : null,
  //     warehouseId: [warehouseIdState],
  //     importType: [props.datasetType],
  //     targetId: props.targetId ? [props.targetId] : null,
  //     source: searchValues?.sourceProcessType
  //       ? [searchValues.sourceProcessType as ImportSource]
  //       : null,
  //     importPipelineId: searchValues?.importPipelineId
  //       ? [searchValues.importPipelineId]
  //       : null,
  //     isUploadOrRestarted:
  //       searchValues?.isUploadOrRestarted === 'true'
  //         ? true
  //         : searchValues?.isUploadOrRestarted === 'false'
  //           ? false
  //           : null,
  //     createdAt: searchValues?.createdAt
  //       ? {
  //           from: searchValues.createdAt
  //             ? new Date(searchValues.createdAt).getTime()
  //             : undefined,
  //           to: searchValues.createdAt
  //             ? new Date(searchValues.createdAt).getTime() + 86400000
  //             : undefined, // Add 24 hours in milliseconds
  //           excludeFrom: false,
  //           excludeTo: false,
  //         }
  //       : null,
  //     updatedAt: searchValues?.updatedAt
  //       ? {
  //           from: searchValues.updatedAt
  //             ? new Date(searchValues.updatedAt).getTime()
  //             : undefined,
  //           to: searchValues.updatedAt
  //             ? new Date(searchValues.updatedAt).getTime() + 86400000
  //             : undefined,
  //           excludeFrom: false,
  //           excludeTo: false,
  //         }
  //       : null,
  //     filename: searchValues?.filename
  //       ? {
  //           type: StringSearchFilterType.CONTAINS,
  //           value: searchValues.filename,
  //         }
  //       : null,
  //     id: searchValues?.id
  //       ? {
  //           type: StringSearchFilterType.CONTAINS,
  //           value: searchValues.id,
  //         }
  //       : null,
  //   };

  //   return filter;
  // }

  // function getSortBy(): ProcessingJobsSortBy[] {
  //   return _.map(sortValues, (value, key, index) => {
  //     const sortObjectKey = sortFieldsMapping[key];
  //     return sortObjectKey ? { field: sortObjectKey, direction: value } : null;
  //   }).filter(i => !!i);
  // }

  function callDataLoad(
    searchValues: Partial<Record<ProcessingJobsDataColumn, string>>,
    sortValues: Partial<Record<ProcessingJobsDataColumn, SortDirection>>,
    page = { isAppend: false, skip: 0 },
  ) {
    // const filter: ProcessingJobsFilter = getFilter();
    // const sortBy: ProcessingJobsSortBy[] = getSortBy();
    cancelLoad();
    loadCallback({
      // filter,
      ...page,
    });
  }

  // const converterConfig: ProcessingJobsConverterConfig = {
  //   columnsConfig,
  // };

  // async function startExportCSV() {
  //   const filename = generateExportFilename({
  //     exportTitle: t`import-jobs`,
  //     brandTitleState,
  //     warehouse,
  //     warehouseIdState,
  //   });

  //   const variables: ProcessingJobsExportJobParams = {
  //     ...processingJobsExportJobParams,
  //     query: LoadProcessingJobsDocument.loc.source.body,
  //     config: converterConfig,
  //     variables: {
  //       filter: {
  //         importType: [props.datasetType],
  //         targetId: props.targetId ? [props.targetId] : null,
  //       },
  //       sortBy: getSortBy(),
  //       page: null,
  //     },
  //     filename: `${filename}.csv`,
  //   };
  //   const { data, errors } = await runExportCSV({
  //     variables,
  //   });

  //   return {
  //     errors: errors,
  //     job: data.createExportJob,
  //   };
  // }

  const isLoading = loadStatus === AsyncLoadStatus.Loading;
  const itemsCount = processingJobs?.content?.length || 0;
  const totalCount = processingJobs?.totalCount ?? 0;

  // const flattenData = getProcessingJobsTableRows(
  //   processingJobs?.content,
  //   converterConfig,
  // );
  const flattenData = processingJobs?.content;

  function onLoadNext() {
    callDataLoad(searchValues, sortValues, {
      isAppend: true,
      skip: itemsCount,
    });
  }

  const enginesOptions: (ButtonSwitchMultiOption & {
    engine: BatchJobEngine;
  })[] = [
    {
      engine: null,
      label: t`Auto (Default)`,
      description: t`Default option for most import jobs, auto-selected based on data size`,
    },
    {
      engine: BatchJobEngine.LAMBDA,
      label: t`Quick`,
      description: t`Best for quick jobs with smaller files`,
    },
    {
      engine: BatchJobEngine.FARGATE,
      label: t`Bulk`,
      description: t`Handles large-scale imports and heavy workloads`,
    },
  ];

  // const selectionFilters: SelectionFilter<ProcessingJobsDataRow>[] = [
  //   {
  //     label: 'Failed',
  //     predicate: row => row.status === 'FAILED',
  //   },
  //   {
  //     label: 'Ready',
  //     predicate: row => row.status === 'READY',
  //   },
  //   {
  //     label: 'Restarted',
  //     predicate: row => row.status === 'RESTARTED',
  //   },
  //   {
  //     label: 'Draft',
  //     predicate: row => row.status === 'CREATED',
  //   },
  // ];

  return (
    <Container hasOverflowY col data-component="ProcessingJobsTable">
      <DatasetTable
        id={'import-jobs-table'}
        // subtitle={t`Jobs`}
        title={t('{Processing} jobs')}
        //  data
        columnsConfig={columnsConfig}
        keyFields={['id']}
        data={flattenData}
        //  actions
        onLoadNext={onLoadNext}
        onSearch={searchValues => setState({ ...state, searchValues })}
        totalCount={totalCount}
        searchValues={searchValues}
        sortBy={sortValues}
        onSort={sortValues => setState({ ...state, sortValues })}
        // onStartExportClick={startExportCSV}
        //  status
        isLoading={isLoading}
        //  style and design
        hasCounter
        isActionable
        isSticky
        checkedValues={selectedJobs}
        hasRowCounter
        hasCheckboxes
        onRowCheck={(row, isSelected) => {
          const newChecked = isSelected
            ? [...selectedJobs, row]
            : _.filter(selectedJobs, current => current.id !== row.id);
          setSelectedJobs(newChecked);
        }}
        onAllCheck={isSelected => {
          if (isSelected) {
            setSelectedJobs(flattenData);
          } else {
            setSelectedJobs([]);
          }
        }}
      />
    </Container>
  );
};

export default ProcessingJobsTable;
